module.exports = __webpack_public_path__ + "static/media/mavic.b1563c8c.jpg";